import { APICore } from './apiCore';

const api = new APICore();

export function variantAdd(data?: any) {
    return api.create('/variant/add', data);
}

export function registerItemBulk(data?: any) {
    return api.create('/item/register/bulk', data);
}

export function editItemBulk(data?: any) {
    return api.update('/item/update', data);
}
